<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.9239 16.1364H7.42392V6.59091H14.9239V16.1364ZM14.9239 5.22727H7.42392C7.06226 5.22727 6.71541 5.37094 6.45968 5.62667C6.20395 5.8824 6.06028 6.22925 6.06028 6.59091V16.1364C6.06028 16.498 6.20395 16.8449 6.45968 17.1006C6.71541 17.3563 7.06226 17.5 7.42392 17.5H14.9239C15.2856 17.5 15.6324 17.3563 15.8882 17.1006C16.1439 16.8449 16.2876 16.498 16.2876 16.1364V6.59091C16.2876 6.22925 16.1439 5.8824 15.8882 5.62667C15.6324 5.37094 15.2856 5.22727 14.9239 5.22727ZM12.8785 2.5H4.69664C4.33499 2.5 3.98814 2.64367 3.73241 2.8994C3.47668 3.15513 3.33301 3.50198 3.33301 3.86364V13.4091H4.69664V3.86364H12.8785V2.5Z" :fill="iconColor"/>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "iconContentCopy",
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
